export const isGuest = (page) => {
    return ['/login'].includes(page)
}